<template>
   <div class="modal" id="fileViewer" ref="viewModal">
       <div class="modal-header white">
          <div class="header-title" ></div>
          <button class="btn-floating btn-flat right modal-close"><i class="material-icons grey-text text-darken-3">close</i></button>
          <button  @click="$_fullView()" class="btn-floating btn-flat right "><i class="material-icons grey-text text-darken-3">fullscreen</i></button>
          <div class="clear"></div>
        </div>
       <div class="modal-content"
        v-bind:class="[fileInView && fileInView.mime_type === 'application/pdf' ? 'no-scroll' :'']"
       >
         <div class="image-viewer"
          v-if="fileInView && fileInView.mime_type === 'image/png' 
                || fileInView && fileInView.mime_type === 'image/jpg'
                || fileInView && fileInView.mime_type === 'image/jpeg'"
          >
           <img  :src="fileInView.source_url" alt="">
         </div>
         <div class="pdf-viewer white" 
          v-if="fileInView && fileInView.mime_type === 'application/pdf'"
         >
            <pdf-block
            :data-file="fileInView.source_url"
            >
            </pdf-block>
         </div>
         <div class="doc-viewer"
         v-if="fileInView.mime_type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
         || fileInView.mime_type === 'application/msword'
         ">
          <iframe :src="`https://view.officeapps.live.com/op/embed.aspx?src=${fileInView.source_url}`"
          width='100%' height='100%' frameborder='0'>
          This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> 
          document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>
         </div>
       </div>
     </div>
</template>
<script>
import pdfBlock from '@/components/pdfBlock.component'
import {initModal} from '@/functions'
export default {
  name:'fileViewer',
  props:{
      fileInView: {
        type: [Boolean, Object],
        default:false
      },
  },
  components:{
    pdfBlock,
  },
  data () {
    return {
       viewModal:{
        instance:null,
        options:{
          onCloseEnd:() =>{
            this.$emit('complete', true)
            //this.fileInView = false
          }
        }
      },
    //  files:new Array,
    }
  },
  computed:{
    videoOptions: {
      get () {
        return {
				autoplay: false,
				controls: true,
        fluid: true,
				sources: [
					{
						src: this.fileInView.source_url,
            type: this.fileInView.mime_type
					}
				]
			}
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.$_initModal()
    }, 300);
  },
  beforeDestroy(){
  return this.viewModal.instance 
    ? this.viewModal.instance.destroy()
    : false
  },
  methods:{
    $_fullView () {
      this.$refs.viewModal.classList.toggle('fullScreen')
    },
    $_initModal(){
      this.viewModal.instance = initModal(this.$refs.viewModal, this.viewModal.options)
      setTimeout(() => {
        this.viewModal.instance.open()
      }, 400);
    },
  }
}
</script>
<style scoped lang="scss">

 #fileViewer {
      border-radius: 6px;
      height: 70%;
    &.fullScreen {
        top: 0 !important;
        left: 0;
        width: 100%;
        height: 100%;
        min-height: 100%;
        min-width: 100%;
      }

    .modal-header {
        width: 100%;
        line-height: 1;
        position: relative;
        padding: 6px 16px;
        border-bottom: 0.75px solid rgba(0,0,0,0.2);
      .header-title {
       float: left;
       font-size: 20px;
       background: white;
       line-height: 40px;
      }
    }
    .modal-content {
      height: calc(100% - 53px);
      position: absolute;
      bottom:0;
      padding: 0px;
      overflow: hidden;
      overflow-y: scroll;
      width:100%;
      .pdf-viewer, .doc-viewer {
        position: relative;
        height: 100%;
      }
      .image-viewer {
        text-align: center;
        position: relative;
        top:50%;
        transform:translateY(-50%);
        img {
          max-width: 100%;
          margin: auto
        }
      }
      &.no-scroll {
        overflow-y: hidden;
      }
    }
  }
</style>